export interface AssignmentDates {
  assignedFrom?: DateInputValue;
  dueOn?: DateInputValue;
  sendReminderOn?: DateInputValue;
}

type DateInputValue = Date | string | null | undefined;

const toTime = (value: DateInputValue) => {
  if (!value) return null;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? null : time;
};

export const validateAssignDateTime = (value: DateInputValue) =>
  validateNotBeforeNow(value);

const validationMessage = (
  key: 'invalidDate' | 'futureDate' | 'onOrAfter' | 'onOrBefore',
  date?: number
) => ({
  message: `moonstar.nudges.assignment.validation.${key}`,
  args: date === undefined ? {} : { date: formatDateTime(date) },
});

function formatDateTime(value: number) {
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(value));
}

export const validateDueOn = (
  value: DateInputValue,
  allValues: AssignmentDates
) => {
  const result = validateNotBeforeNow(value);
  if (result) return result;

  const due = toTime(value);
  const assign = toTime(allValues.assignedFrom);
  return due !== null && assign !== null && due < assign
    ? validationMessage('onOrAfter', assign)
    : undefined;
};

export const validateSendReminderOn = (
  value: DateInputValue,
  allValues: AssignmentDates
) => {
  const result = validateNotBeforeNow(value);
  if (result) return result;

  const reminder = toTime(value);
  const assign = toTime(allValues.assignedFrom);
  const due = toTime(allValues.dueOn);
  if (reminder !== null && assign !== null && reminder < assign) {
    return validationMessage('onOrAfter', assign);
  }
  return reminder !== null && due !== null && reminder > due
    ? validationMessage('onOrBefore', due)
    : undefined;
};

function validateNotBeforeNow(value: DateInputValue) {
  if (!value) return undefined;
  const time = toTime(value);
  if (time === null) return validationMessage('invalidDate');
  return time < Date.now() ? validationMessage('futureDate') : undefined;
}
